var learningCenterPage = 1;

(function ($) {
    loadMoreLearningCenterArticles = function () {
        learningCenterPage++;
        $.post(
            "/Umbraco/Api/LearningCenterAPI/LoadArticles",
            "PageNumber=" + learningCenterPage,
            function (data) {
                console.log(data);
                var jsonData = $.parseJSON(data);
                if (jsonData.totalArticles > 0)
                {
                    for (var a = 0; a < jsonData.totalArticles; a++)
                    {
                        $("#learning-center-article-listing").append(
                            "<li>" +
                            "<article>" +
                            "<a href=\"" + jsonData.articles[a].articleURL + "\">" +
                            "<img src=\"" + jsonData.articles[a].imageURL + "\" alt=\"" + jsonData.articles[a].imageAltText + "\">" +
                            "</a> " +
                            "<small>" + jsonData.articles[a].formattedDate + "</small>" +
                            "<h2>" +
                            "<a href=\"" + jsonData.articles[a].articleURL + "\">" + jsonData.articles[a].articleName + "</a>" +
                            "</h2>" +
                            "<div>" + jsonData.articles[a].previewCopy + "</div>" +
                            "<p class=\"article-link\">" +
                            "<a href=\"" + jsonData.articles[a].articleURL + "\">Read article</a>" +
                            "<i class=\"btl bt-long-arrow-right\"></i>" +
                            "</p>" +
                            "</article>" +
                            "</li>"
                        );
                    }
                }
                else
                {
                    $("#learning-center-load-articles-button").hide();
                }
            },
            "json"
        ).fail(function () {
            $("#learning-center-article-listing-status-message").html("Sorry, additional articles are currently unavailable.");
            $("#learning-center-load-articles-button").hide();
        });
    };
})(jQuery);